import {
	AspectRatioContainer,
	Carousel,
	Image,
	Lentils,
	MediaGalleryArrowButtons,
	MediaGalleryContextProvider,
	MediaGallerySlide,
	styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { getFinanciacionType, getPagoFinanciado, getPagoUnico } from '../../helpers/ofertas-helper';
import { Oferta } from '../../services/ofertas-service/models/ofertas';
import { useTrackingManager } from '../../tracking/use-tracking-manager';
import { COLOR } from '../constant-styles';

const GalleryWrapper = styled.div`
	position: relative;

	@media screen and (max-width: 959px) {
		padding-top: ${(props) => props.theme.size.dynamic0100};

		& > div:first-child {
			height: 50vh !important;
		}
	}

	@media screen and (min-width: 960px) {
		position: absolute;
		top: 0;
		right: 0;
		padding-top: 0;
		width: 50%;
		height: 100%;

		& > div:first-child {
			height: 100% !important;
		}
	}
`;

const LentilsWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: -50px;
	margin-bottom: 50px;

	& > div {
		background-color: ${COLOR.DARK_GREY_70};
	}
`;

export const ImageGallery = ({ oferta }: { oferta: Oferta }): React.ReactElement => {
	const trackingManager = useTrackingManager();

	const selectImage = (index: number) => {
		const pagoFinanciado = getPagoFinanciado(oferta.datosEconomicos);
		trackingManager.trackOfertasButtonClick(
			`model-image-${index + 1}`,
			{ contentId: `model-image-${index + 1}` },
			{
				CarlineId: oferta.carline?.code.toString(),
				CarlineName: oferta.carline?.title,
				ModelId: oferta.configuracion.motorizacion.code?.split('-')[0],
				ModelName: oferta.carline?.salesgroup.model.name,
				ModelYear: oferta.carline?.salesgroup.year.toString(),
				SalesgroupName: oferta.carline?.salesgroup.title,
				PriceRateType: pagoFinanciado ? getFinanciacionType(pagoFinanciado) : undefined,
				PriceRateTotal: pagoFinanciado?.precio ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal: getPagoUnico(oferta.datosEconomicos)?.precio ?? undefined,
				PriceTotalCurrency: 'EUR',
			},
		);
	};

	return (
		<GalleryWrapper className="gallery-wrapper">
			<MediaGalleryContextProvider>
				<>
					<AspectRatioContainer ratio="1:1">
						<Carousel hasBorderRadius={false}>
							{oferta.galeria.map((image, i) => (
								<MediaGallerySlide key={i}>
									<Image alt="image" src={image} objectFit="cover" style={{ height: '100%' }} />
								</MediaGallerySlide>
							))}
						</Carousel>
					</AspectRatioContainer>
					<MediaGalleryArrowButtons ariaLabelNext={'Anterior'} ariaLabelPrev={'Siguiente'} />
				</>
				<LentilsWrapper>
					<Lentils onChange={(i) => selectImage(i)} />
				</LentilsWrapper>
			</MediaGalleryContextProvider>
		</GalleryWrapper>
	);
};
